module.exports = __webpack_public_path__ + "img/slack.06445fd2.png";